import { JiraState, JiraAction, DO_FETCH_JIRA, FAIL_JIRA, LOAD_JIRA } from "./JiraTypes";
import {
  failedStatus,
  idleLoadStatus,
  loadingStatus,
  succeededStatus,
} from "../redux/LoadStatus";

const initialState: JiraState = {
  synching: false,
  status: idleLoadStatus,
  projects: [],
  projectCategories: [],
};

export default function jiraReducer(
  state = initialState,
  action: JiraAction
): JiraState {
  switch (action.type) {
    case DO_FETCH_JIRA: {
      return {
        ...state,
        synching: true,
        status: loadingStatus(),
      };
    }
    case LOAD_JIRA: {
      return {
        synching: false,
        status: succeededStatus(action.loadedAt),
        projects: action.projects,
        projectCategories: action.projectCategories,
      };
    }
    case FAIL_JIRA: {
      return {
        ...state,
        synching: false,
        status: failedStatus(action.error),
      };
    }
    default:
      return state;
  }
}
